
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.752 6.72A7.275 7.275 0 0012 6.5c-3.495 0-6.99 2.744-8.882 5.91a.819.819 0 000 .846C5.01 16.423 8.505 19.167 12 19.167s6.99-2.744 8.882-5.91a.818.818 0 000-.846 13.59 13.59 0 00-1.175-1.664","stroke":"#262626","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M19 5.5l-6.75 9L10 11.658","stroke":"#3092D0","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    